import { styled, Toolbar, Box } from '@mui/material'
import { getFlexValue } from '../../../utils/processStyles'
import Text from '../Text'
import { MainHeaderProps, MainHeaderStyleProps } from './MainHeader.types'

export const MainHeaderWrapper = styled(Toolbar, {
  name: 'MainHeader'
})(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: '56px',
  gap: '12px',

  [theme.breakpoints.up('sm')]: {
    paddingLeft: '16px',
    paddingRight: '16px'
  }
}))

MainHeaderWrapper.defaultProps = {
  variant: 'dense'
}

export const Subtitle = styled(Text)(() => ({
  marginTop: '-2px'
}))

Subtitle.defaultProps = {
  size: '12px'
}

export const MainHeaderSide = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  minWidth: '28px',

  '&:first-of-type': {
    marginLeft: '-8px'
  },
  '&:last-of-type': {
    marginRight: '-8px'
  }
}))

export const MainHeaderContent = styled(Box)<MainHeaderStyleProps>(
  ({ align }) => ({
    flex: 1,
    display: 'flex',
    justifyContent: getFlexValue(align),
    alignItems: 'center',
    gap: 8
  })
)

export const MainHeaderTextContent = styled(MainHeaderContent)<MainHeaderProps>(
  ({ subtitle }) => ({
    flexDirection: `${subtitle ? 'column' : 'row'}`,
    gap: 4
  })
)
